import React, { Component } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import './Checkbox.css';

class Checkbox extends Component {
  constructor(props) {
    super(props);

    this.getClassNames = this.getClassNames.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);

    const { onKeyPress } = this.props;
    this.state = {
      onKeyPress: onKeyPress || this.handleKeyPress,
    };
  }

  getClassNames() {
    const { checked, disabled, className } = this.props;
    return classnames({
      Checkbox: true,
      [className]: true,
      checked,
      disabled,
    });
  }

  handleClick() {
    const {
      checked, disabled, name, onClick, onChange,
    } = this.props;
    if (disabled) {
      return;
    }
    if (onClick) {
      onClick(name, !checked);
    }
    if (onChange) {
      onChange(name, !checked);
    }
  }

  handleKeyPress(e) {
    if (e.key === ' ') {
      this.handleClick(e);
    }
  }

  render() {
    const { getClassNames, handleClick } = this;
    const { checked, disabled, test } = this.props;
    const { onKeyPress } = this.state;
    const tabIndex = disabled ? '-1' : '0';
    return (
      <div
        className={getClassNames()}
        tabIndex={tabIndex}
        role="checkbox"
        aria-checked={checked}
        onClick={handleClick}
        onKeyPress={onKeyPress}
        test={test}
      >
        <span className="overlay" />
      </div>
    );
  }
}

Checkbox.propTypes = {
  checked: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  onKeyPress: PropTypes.func,
  test: PropTypes.string,
};

Checkbox.defaultProps = {
  checked: false,
  className: '',
  disabled: false,
  onClick: null,
  onChange: null,
  onKeyPress: null,
  test: null,
};

export default Checkbox;
